module.exports = __webpack_public_path__ + "img/home@2x.f8d57372.webp";